import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

interface DeleteModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    email?: string;
}

export default function DeleteModal({
    isOpen,
    onClose,
    onConfirm,
    email,
}: DeleteModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
                className="absolute inset-0 bg-black bg-opacity-50"
                onClick={onClose}
            />

            <div className="relative bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-6 w-full max-w-md shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                    <FaExclamationTriangle className="text-red-500 text-2xl" />
                    <h2 className="text-xl font-semibold">Confirm Deletion</h2>
                </div>

                <p className="mb-6 text-gray-600 dark:text-gray-300">
                    Are you sure you want to delete{" "}
                    <span className="font-medium">{email ?? "this user"}</span>?
                    This action cannot be undone.
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}
